import styled from "styled-components";

export const Caption = styled.span`
  ${props => ({ ...props.theme.font.caption })}
  color: ${props => props.color || props.theme.colors.black};
`;
